var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.006 20.19c-.062-.038-.126-.077-.19-.118a4.205 4.205 0 00-4.71 0 3.344 3.344 0 01-3.798 0 3.963 3.963 0 00-2.356-.72 3.953 3.953 0 00-2.352.72 3.108 3.108 0 01-1.9.592 3.097 3.097 0 01-1.898-.592 4.848 4.848 0 00-1.096-.542l-.271 1.155.004.001-.032.136a3.872 3.872 0 01.906.455A3.957 3.957 0 008.662 22a3.952 3.952 0 002.349-.723 3.078 3.078 0 011.89-.59 3.101 3.101 0 011.896.59 4.169 4.169 0 004.693 0 3.336 3.336 0 013.787 0l.054.034.083-.138zm2.849-5.144a.302.302 0 00-.186-.041H23.66l-1.282-5.138c-.042-.14-.16-.195-.359-.195h-1.858l-.29-1.344a.346.346 0 00-.443-.204l-.004.001-2.101.889a.458.458 0 00-.345.512v1.638H9.253a.378.378 0 00-.354.347l-.779 3.486H6.826a.33.33 0 00-.332.25l-.56 2.912a6.167 6.167 0 011.328.546 2.477 2.477 0 001.411.379 2.483 2.483 0 001.413-.38 5.527 5.527 0 012.842-.73 5.532 5.532 0 012.844.73 2.48 2.48 0 001.412.38 2.474 2.474 0 001.411-.38 5.904 5.904 0 015.688 0l.21.108 2.466-3.352a.301.301 0 00-.104-.414zM12.6 15.005H9.074l.392-1.846h3.135zm4.28 0h-3.578v-1.846h3.579zm.676 0v-1.846h3.547l.372 1.846z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--boat-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'BoatCircleIcon';
export default Icon;